<template>
  <div class="main-page-view-list">
    <el-row :gutter="20">
      <el-col :span="1">
        <div class="icon-par-div">
          <svg t="1696831858149" class="icon-par-essay" viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="5080" width="200" height="200">
            <path
                d="M509.53728 510.21824m-473.51808 0a473.51808 473.51808 0 1 0 947.03616 0 473.51808 473.51808 0 1 0-947.03616 0Z"
                fill="#EEDBC3" p-id="5081"></path>
            <path
                d="M509.53728 510.21824m-406.46144 0a406.46144 406.46144 0 1 0 812.92288 0 406.46144 406.46144 0 1 0-812.92288 0Z"
                fill="#78CEF4" p-id="5082"></path>
            <path
                d="M759.13216 550.53824c-30.91456-49.0752-85.23264-81.92-147.52256-81.92-66.28864 0-123.85792 36.992-153.44128 91.39712h-1.46944c29.42976 54.92224 87.33696 92.30336 154.0096 92.30336 63.13984 0 118.0672-33.76128 148.74112-83.96288a113.4592 113.4592 0 0 0 75.68896 48.37888v-116.0192c-31.81056 5.34016-59.02336 23.8848-76.0064 49.82272z"
                fill="#FCE38A" p-id="5083"></path>
            <path
                d="M399.05792 452.89984m-26.19392 0a26.19392 26.19392 0 1 0 52.38784 0 26.19392 26.19392 0 1 0-52.38784 0Z"
                fill="#FFFFFF" p-id="5084"></path>
            <path
                d="M298.47552 352.31744m-47.15008 0a47.15008 47.15008 0 1 0 94.30016 0 47.15008 47.15008 0 1 0-94.30016 0Z"
                fill="#FFFFFF" p-id="5085"></path>
            <path
                d="M527.2832 547.71712l7.50592-12.99968c7.81312 4.70016 19.36384 8.90368 28.76928 8.90368 9.45664 0 21.33504-4.39296 29.17888-9.14432l7.2192 13.1584c-10.69056 7.03488-23.12192 11.08992-36.4032 11.08992-13.22496-0.00512-25.61024-4.02432-36.27008-11.008z"
                fill="#5B5144" p-id="5086"></path>
          </svg>
        </div>
      </el-col>
      <el-col :span="23">
        <div class="essay-title">
          <div class="essay-title-info">{{ item.title }}</div>
        </div>
        <div class="essay-time">
          <div class="essay-time-info">发布时间:{{ item.viewTime }}</div>
        </div>
        <div class="essay-info">
          <div class="essay-info-div">{{ item.info }}</div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="1"></el-col>
      <el-col :span="23">
        <img v-if="item.img" class="essay-img" :src="item.img">
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "essayBlock",
  data() {
    return {}
  },
  props: ['item'],
  created() {

  },
}
</script>

<style scoped>
.main-page-view-list {
  margin-top: 15px;
  background-color: #fff;
  border-radius: 5px;
  min-height: 100px;
  width: 100%;
  overflow: hidden;
  transition: 1s;
}

.main-page-view-list::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-radius: 5px;
  border-top: 2px solid #96e6a1;
  border-left: 2px solid #96e6a1;
  transition: 1s;
}

.main-page-view-list::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
  border-radius: 5px;
  border-right: 2px solid #96e6a1;
  border-bottom: 2px solid #96e6a1;
  transition: 1s;
}

.main-page-view-list:hover::before, .main-page-view-list:hover::after {
  width: 100%;
  height: 100%;
}

.main-page-view-list:hover {
  cursor: pointer;
  color: #42b8f1;
  background-color: #e7f5e1;
  box-shadow: 0 0 50px #e7f5e1;
  transition-delay: .5s;
}

.essay-title {
  font-size: 20px;
  /*background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);*/
  border-radius: 5px;
  height: 40px;
  line-height: 40px;
}

.essay-info {
  width: 100%;
  height: 30px;
  font-size: 15px;
  margin-top: 10px;
}

.essay-info-div {
  margin-left: 15px;
  font-family: 华文仿宋;
}

.essay-title-info {
  margin-left: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #42b983;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.essay-img {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 15px;
  width: 300px;
  height: 200px;
}

.essay-time {
  font-size: 12px;
  height: 14px;
  line-height: 14px;
}

.essay-time-info {
  margin-left: 15px;
  font-size: 14px;
  font-family: 方正舒体;
}

.icon-par-div {
  height: 40px;
}

.icon-par-essay {
  width: 25px;
  height: 25px;
  margin-top: 7px;
  margin-left: 20px;
}
</style>